import React, {Component} from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BMI, BmiCss, BloodPress, BloodPressCss } from "../form/rumus";
import "react-tabs/style/react-tabs.css";
import apiService from "apiService.js";
import Assesment from "../form/Assesment";
import SubjectiveSanitasi from "./SubjectiveSanitasi";
import ObjectiveSanitasi from "./ObjectiveSanitasi";
import PlanningSanitasi from "./PlanningSanitasi";

export default class Sanitasi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visitId: 0,
            modules: [
                { id: "1", name: "Subjektif" },
                { id: "2", name: "Objektif" },
                { id: "3", name: "Assesment" },
                { id: "4", name: "Planning" },
            ],
            visible: false,
            detilPx: this.props.detilPx,
            tabIndex: 0,
            histories : [],
            dataObjectiveGizi: {},
            nutrition: {}
        };
        this.parentCallback = this.parentCallback.bind(this);
        this.nextTab = this.nextTab.bind(this);
    }

    componentDidMount() {
        this.getHistories();
    }

    getHistories = async () => {
        const res = await apiService.get(
            "registration/history/" + this.props.detilPx.patients.id
        );
        if (res.code === 200) {
            let histories = res.data.histories.data.reverse();
            this.setState({
                histories: histories
            });
        }
    }

    buttonClick = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    parentCallback(data) {
        this.setState((prevState) => ({
            detilPx: {
                ...prevState.detilPx,
                [data.param]: data.data,
            },
        }));
    }

    getData = async () => {
        let param = {
            keyword: {
                visitId: this.state.detilPx.id,
            },
            limit: 10,
            frDate: "",
            enDate: "",
        };

        const res = await apiService.post("registration", param);
        if (res?.status === "success.") {
            this.setState({
                detilPx: res.data.data[0],
            });
            this.forceUpdate();
        }
    };

    nextTab() {
        const tabs = this.state.tabIndex;
        const tabIndex = tabs + 1;
        this.setState({ tabIndex: tabIndex });
        window.scrollTo(0, 50);
    }

    render() {
        var patient = this.state.detilPx;
        return (
            <div>
                <div className='card'>
                    <div className='card-header'>
                        <div className='row align-items-center'>
                            <div className='col'>
                                <span className='h3 mb-0 '>Form Pemeriksaan Sanitasi</span>
                                <span className='ml-2 mt--1'>
                                  <a
                                      className='btn btn-sm btn-twitter btn-icon-only rounded-circle'
                                      onClick={this.getData}>
                                    <i
                                        className='fa fa-refresh'
                                        style={{ color: "white" }}
                                        aria-hidden='true'></i>
                                  </a>
                                </span>
                            </div>
                            <div
                                className={BmiCss(
                                    patient.examinations[0].weight,
                                    patient.examinations[0].height
                                )}>
                                {BMI(
                                    patient.examinations[0].weight,
                                    patient.examinations[0].height
                                )}
                            </div>
                            <div
                                className={BloodPressCss(
                                    patient.examinations[0].sistole,
                                    patient.examinations[0].diastole
                                )}
                                style={{ marginLeft: "2%" }}>
                                <b>
                                    {" "}
                                    {BloodPress(
                                        patient.examinations[0].sistole,
                                        patient.examinations[0].diastole
                                    )}{" "}
                                </b>
                            </div>
                        </div>
                    </div>
                    <div className='card-body'>
                        <Tabs
                            selectedIndex={this.state.tabIndex}
                            onSelect={(tabIndex) => this.setState({ tabIndex })}>
                            <TabList>
                                <Tab id='Subjektif'>Subjektif </Tab>
                                <Tab id='Objektif'>Objektif </Tab>
                                <Tab id='Assesment'>Assesment </Tab>
                                <Tab id='Planning'>Planning </Tab>
                            </TabList>
                            <TabPanel tabId='Subjektif'>
                                <SubjectiveSanitasi
                                    patient={patient}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId='Objektif'>
                                <ObjectiveSanitasi
                                    patient={patient}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId='Assesment'>
                                <Assesment
                                    patient={patient}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId='Planning'>
                                <PlanningSanitasi
                                    patient={patient}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                    nutrition={this.state.nutrition}
                                />
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}